import { useSelector } from 'react-redux';
import { FC, useCallback } from 'react';
import { OfferTypePopupPostfix } from './containers';
import { DropdownFilter, DropdownSelect, DropdownOfferType, useDropdown } from 'shared/components/DropdownFilter';
import { FILTER_KEY } from './constants';
import { selectOfferTypeFilter } from 'shared/selectors/filters';
import { useAppDispatch, useShowSearchMetaTooltip, useOfferTypeChangeHandler } from 'shared/hooks';
import { selectDealType, selectOfferType } from 'shared/selectors/jsonQuery';
import { updateOfferType } from 'shared/slices/jsonQuery';
import { FOfferType } from '../../../packages/JsonQuery';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';

export const OfferTypeContainer: FC = () => {
  const dispatch = useAppDispatch();

  const { label, value, options } = useSelector(selectOfferTypeFilter);
  const offerType = useSelector(selectOfferType);
  const dealType = useSelector(selectDealType);

  const dropdownState = useDropdown(FILTER_KEY);

  const onChange = useOfferTypeChangeHandler(FILTER_KEY);

  const onOfferTypeChange = useCallback(
    (value: FOfferType) => {
      dispatch(updateOfferType(value));
    },
    [dispatch],
  );

  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  return (
    <DropdownFilter
      {...dropdownState}
      buttonLabel={label}
      showTooltip={showTooltip}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={
        isFiltersRedesignEnabled ? (
          <DropdownOfferType
            dealType={dealType}
            offerType={offerType}
            options={options}
            value={value}
            onChange={onChange}
            onOfferTypeChange={onOfferTypeChange}
          />
        ) : (
          <DropdownSelect
            multiple
            options={options}
            value={value}
            postfix={<OfferTypePopupPostfix />}
            onChange={onChange}
          />
        )
      }
    />
  );
};
